import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=18ecf173"
import script from "./Policy.vue?vue&type=script&lang=js"
export * from "./Policy.vue?vue&type=script&lang=js"
import style0 from "./Policy.vue?vue&type=style&index=0&id=18ecf173&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports